__webpack_require__.p = "/votesafe-dapp/";